import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import './ExamSelection.css'; 
import API_BASE_URL from '../config';

const ExamSelection = () => {
    const { type } = useParams();
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true); 
    const navigate = useNavigate();

    // Cấu hình icon và lời chào theo từng kỹ năng để tăng tính thẩm mỹ
    const skillTheme = {
        reading: { icon: '📚', label: 'Reading Test' },
        listening: { icon: '🎧', label: 'Listening Test' },
        writing: { icon: '✍️', label: 'Writing Test' }
    };

    const currentTheme = skillTheme[type?.toLowerCase()] || { icon: '📝', label: 'Exam Papers' };

    useEffect(() => {
        const fetchExams = async () => {
            setLoading(true);
            try {
                const examType = type?.toLowerCase()?.trim();
                const res = await axios.get(`${API_BASE_URL}/api/exams/${examType}`);
                setExams(res.data);
            } catch (err) {
                console.error("Lỗi kết nối API khi lấy danh sách đề thi:", err);
            } finally {
                setLoading(false);
            }
        };

        if (type) fetchExams();
    }, [type]);

    return (
        <div className="selection-container">
            <Header />
            
            <main className="selection-content">
                {/* Section Header mới tinh tế hơn */}
                <div className="selection-header-block">
                    <span className="skill-emoji-bg">{currentTheme.icon}</span>
                    <h2 className="selection-title">Choose Your {currentTheme.label}</h2>
                </div>
                
                <div className="exam-grid">
                    {loading ? (
                        <div className="loading-wrapper">
                            <div className="loading-spinner"></div>
                            <p>Searching for the best papers...</p>
                        </div>
                    ) : exams.length > 0 ? (
                        exams.map((exam, index) => (
                            <div key={exam.test_id} className="exam-card">
                                <div className="card-top">
                                    <span className="test-index">TEST #{index + 1}</span>
                                    <span className={`exam-tag tag-${type.toLowerCase()}`}>
                                        {type.toUpperCase()}
                                    </span>
                                </div>

                                <div className="exam-info">
                                    <h3>{exam.test_name || exam.title}</h3>
                                    <div className="exam-meta">
                                  {/* <span className="meta-item">📅 Year: <strong>{exam.year || 'N/A'}</strong></span>*/}
                                  {/*<span className="meta-item">🆔 ID: {exam.test_id}</span>*/}
                                    </div>
                                </div>

                                <button 
                                    className="start-exam-btn"
                                    onClick={() => navigate(`/instructions/${type}/${exam.test_id}`)}
                                >
                                    Start Practice <span>→</span>
                                </button>
                            </div>
                        ))
                    ) : (
                        <div className="no-data-card">
                            <span className="no-data-icon">🏜️</span>
                            <p>No {type?.toLowerCase()} papers found at the moment.</p>
                            <button className="back-home-btn" onClick={() => navigate('/dashboard')}>Go Back</button>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default ExamSelection;